
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ErrorStateProps {
  error: Error | null;
  onRetry: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  return (
    <Card className="border-destructive">
      <CardHeader>
        <CardTitle className="flex items-center text-destructive">
          <AlertTriangle className="h-6 w-6 mr-2" />
          Database Error
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="mb-2 text-muted-foreground">There was an error accessing the PEO verifications data:</p>
        <pre className="bg-muted p-4 rounded-md overflow-auto text-xs">
          {error instanceof Error ? error.message : 'Unknown error'}
        </pre>
        <p className="mt-4 text-sm">
          This may be due to a database policy configuration issue. Please contact the system administrator.
        </p>
        <Button 
          onClick={onRetry} 
          variant="outline" 
          className="mt-4"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Try Again
        </Button>
      </CardContent>
    </Card>
  );
};
